import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import FirmSelector from '../components/FirmSelector';

const FirmSelectorRoot = document.getElementById('FirmSelector');

class FirmInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  render() {
    return (
      <FirmSelector
        required
        useFirmSuggester
        value={this.state.value}
        onChange={value => this.setState({ value })}
        label="Firm Name"
        name="firm_id"
      />
    );
  }
}

if (FirmSelectorRoot) {
  ReactDOM.render(
    <FirmInput />,
    FirmSelectorRoot,
  );
}
